import auth from '@/components/fireAuthInit';
import db from '@/components/firebaseInit'
import router from '@/router'
import { siginInErrorCodeToMessage } from '@/utils/errorMessages.js'


export default {
    namespaced: true,
    state: {   // state.userは常に存在します
        user: undefined, // ユーザー情報を格納する。ログインしてないときはundefined
        errorMessage: "",
        user_type: "",
        team_name: "",
        work_type: "",
        authorities: [],
        toUrl: ""
    },
    mutations: {
        changeAuthState(state, user) {
            state.user = user;  //受け取ったuserを保存する
            state.user_type = user ? user.profile.user_type : null
            state.team_name = user ? user.profile.team_name : null
            state.work_type = user ? user.profile.work_type : null
            state.authorities = user ? authorities[user.profile.user_type] : null
            
        },
        changeErrorMessage(state, e) {
            state.errorMessage = siginInErrorCodeToMessage(e.code)
        },
        saveToUrl(state, url) {
            state.toUrl = url
        },
        clearToUrl(state) {
            state.toUrl = ""
        }
    },
    getters: {
        user(state) {
            return state.user;  //user()が呼ばれると、保存されたユーザー情報を返す
        },
        profile(state) {
            return state.user && state.user.profile ? state.user.profile : undefined;  //user()が呼ばれると、保存されたユーザー情報を返す
        },
        isLoggedIn(state) {
            return !!state.user
        },
        CanI: (state) => (auth) => {
            return state.authorities ? state.authorities.includes(auth) : false

        },
        toUrl(state) {
            return state.toUrl
        }

    },
    actions: {
        logIn({ commit }, account) {
            return new Promise((resolve, reject) => {
                auth.signInWithEmailAndPassword(account.email, account.password).then(user => {
                    //router.push({ name: "home", params: { user_id: user.user.uid } })
                    resolve()
                }).catch((e) => {
                    console.error(e)
                    commit("changeErrorMessage", e)
                    reject(e)
                })
            })
        },
        logOut({ commit }) {
            auth.signOut()
            commit("clearToUrl")
            router.push({ name: "login" })
        },
        async updateUserExtraData({ commit, state }, extraData) {
            const doc = await db.collection('users').doc(state.user.uid).set(extraData)
            store.commit("auth/changeAuthState", { ...state.user, extraData })
        }
    }
}


export function authInit(store) {
    auth.onAuthStateChanged(async user => {
        if (user) {
            try {
                const doc = await db.collection('users').doc(user.uid).get()
                const extraData = doc.exists ? doc.data() : {}
                store.commit("auth/changeAuthState", { ...user, profile: extraData, })
                const url = store.getters['auth/toUrl']
                if (url == "") {
                    if (store.getters['auth/CanI']('HaveNoTimesheet')) {
                        router.push({ name: "manage_attendance" })
                    } else {
                        router.push({ name: "home", params: { user_id: user.uid } })
                    }

                } else {
                    router.push({ path: url })
                    store.commit("auth/clearToUrl")
                }
            } catch (e) {
                console.error(e)
            }

        } else {
            store.commit("auth/changeAuthState", undefined)
        }
    })
}

const authorities = {
    "スタッフ": [],
    "リーダー": ["UseMenu", "ManageMyTeam", "ApproveTimesheet"],
    "集計": ["UseMenu", "ManageAllTeam"],
    "役員": ["UseMenu", "ManageAllTeam", "HaveNoTimesheet", , 'ReadOtherMoneyTable', "ApproveTimesheet", "ManagePaidDaysOff"],
    "管理": ["UseMenu", "ManageAllTeam", "HaveNoTimesheet", "UseAttendanceResult", 'ReadOtherMoneyTable', "ApproveTimesheet", "ManagePaidDaysOff", "EditUser", "DowndoadAttendance","ImportTimecards"],
    "VBPO": ["UseMenu", "ManageAllTeam", "HaveNoTimesheet", , 'ReadOtherMoneyTable', "UseAttendanceResult", "CannotEdit"],
}